import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconNdrysho = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 14 14",
	style: { enableBackground: "new 0 0 14 14" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.st0{fill:#FFFFFF;}\n	.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n	.st2{clip-path:url(#SVGID_00000150095162948153196110000000343066519361479581_);}\n	.st3{clip-path:url(#SVGID_00000149373799831424193490000001055284926283052476_);}\n	.st4{fill:#F2F2F2;}\n	.st5{fill:#BDB6B8;}\n	.st6{fill:#1A1A1A;}\n	.st7{fill:#ADA8AA;}\n	.st8{fill:#262424;}\n	.st9{fill:#1E8273;}\n	.st10{fill:#239281;}\n	.st11{fill:#262626;}\n	.st12{fill:#0F0F0F;}\n	.st13{fill:#212226;}\n	.st14{opacity:0.25;}\n	.st15{clip-path:url(#SVGID_00000033336141838956197840000005155688556602492856_);}\n	.st16{opacity:0.15;}\n	.st17{clip-path:url(#SVGID_00000069366834107702308560000000590736418139380395_);}\n"
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_7431_00000060022719262200020110000009623688766172120195_",
		className: "st0",
		d: "M0,11.2v2.4C0,13.8,0.2,14,0.4,14 c0,0,0,0,0,0h2.4C2.9,14,3,14,3,13.9l8.5-8.5L8.6,2.5L0.1,11C0,11,0,11.1,0,11.2z M13.8,3.1c0.3-0.3,0.3-0.8,0-1.1c0,0,0,0,0,0 L12,0.2c-0.3-0.3-0.8-0.3-1.1,0c0,0,0,0,0,0L9.4,1.7l2.9,2.9L13.8,3.1L13.8,3.1z"
	})]
});
export { SvgIconNdrysho as ReactComponent };
